// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './api/axios'
import store from './store'
import ElementUI from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/css/swiper.css'
import '../styles/common.scss' // global css
import VueClipBoard from 'vue-clipboard2'
Vue.config.productionTip = false
Vue.prototype.$api = axios

Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.use(VueClipBoard)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js